import { ActionTypes } from '../../../Model/Enum/BEE123Enums';
import { IDropDownOptions } from '../../Components/FormValidationInputs/AppSelectList';

export const EEOccupationalLevelList: IDropDownOptions[] = [
	{ value: 'Executive Director', id: 1 },
	{ value: 'Other Executive Management', id: 4 },
	{ value: 'Senior Management', id: 5 },
	{ value: 'Middle Management', id: 6 },
	{ value: 'Junior Management', id: 7 },
	{ value: 'Semi skilled', id: 8 },
	{ value: 'Unskilled', id: 9 },
];

export const AllOccupationalLevelList: IDropDownOptions[] = [
	{ value: 'Executive Director', id: 1 },
	{ value: 'Non Executive Director', id: 2 },
	{ value: 'Executive Management', id: 3 },
	{ value: 'Other Executive Management', id: 4 },
	{ value: 'Senior Management', id: 5 },
	{ value: 'Middle Management', id: 6 },
	{ value: 'Junior Management', id: 7 },
	{ value: 'Semi skilled', id: 8 },
	{ value: 'Unskilled', id: 9 },
	{ value: 'Unspecified', id: 10 },
];

export const EmployeeLevelList: IDropDownOptions[] = [
	{ value: 'Employee', id: 1 },
	{ value: 'Employed by Other', id: 2 },
	{ value: 'Unemployed', id: 3 },
	{ value: 'Employee Previously Unemployed', id: 4 },
];

export const EmployeeStructureEmployeeTypeList: IDropDownOptions[] = [
	{ value: 'Employee', id: 1 },
	{ value: 'Employee Previously Unemployed', id: 4 },
];

export const genderList: IDropDownOptions[] = [
	{ id: 1, value: 'Male' },
	{ id: 2, value: 'Female' },
];

export const raceList: IDropDownOptions[] = [
	{ value: 'African', id: 1 },
	{ value: 'Coloured', id: 2 },
	{ value: 'Indian', id: 3 },
	{ value: 'White', id: 4 },
	{ value: 'Non South African', id: 5 },
];

export const provinceList: IDropDownOptions[] = [
	{ value: 'Unspecified', id: 0 },
	{ value: 'Eastern Cape (EC)', id: 2 },
	{ value: 'Free State (FS)', id: 3 },
	{ value: 'Gauteng (GP)', id: 4 },
	{ value: 'KwaZulu-Natal (KZN)', id: 5 },
	{ value: 'Limpopo (LP)', id: 6 },
	{ value: 'Mpumalanga (MP)', id: 7 },
	{ value: 'North West (NW)', id: 8 },
	{ value: 'Northern Cape (NC)', id: 9 },
	{ value: 'Western Cape (WC)', id: 10 },
];

export const setaClassificationList: IDropDownOptions[] = [
	{ value: 'Agricultural Sector Education and Training Authority', id: 1 },
	{ value: 'Banking Sector Education and Training Authority', id: 2 },
	{ value: 'Chemical Industries Education and Training Authority', id: 3 },
	{ value: 'Construction Education and Training Authority', id: 4 },
	{
		value:
			'Culture, Arts, Tourism, Hospitality and Sport Sector Education and Training Authority',
		id: 5,
	},
	{
		value:
			'Education, Training and Development Practices Sector Education and Training Authority',
		id: 6,
	},
	{ value: 'Energy and Water Sector Education and Training Authority', id: 7 },
	{
		value:
			'Fibre Processing and Manufacturing Sector Education and Training Authority',
		id: 8,
	},
	{
		value:
			'Finance and Accounting Services Sector Education and Training Authority',
		id: 9,
	},
	{
		value:
			'Food and Beverage Manufacturing Industry Sector Education and Training Authority',
		id: 10,
	},
	{
		value: 'Health and Welfare Sector Education and Training Authority',
		id: 11,
	},
	{ value: 'Insurance Sector Education and Training Authority', id: 12 },
	{ value: 'Local Government Sector Education and Training Authority', id: 13 },
	{
		value:
			'Manufacturing, Engineering and Related Services Sector Education and Training Authority',
		id: 14,
	},
	{
		value:
			'Media, Information and Communication Technologies Sector Education and Training Authority',
		id: 15,
	},
	{ value: 'Mining Qualifications Authority ', id: 16 },
	{ value: 'Public Service Sector Education and Training Authority', id: 17 },
	{
		value: 'Safety and Security Sector Education and Training Authority',
		id: 18,
	},
	{ value: 'Services Sector Education and Training Authority', id: 19 },
	{ value: 'Transport Education Training Authority', id: 20 },
	{
		value: 'Wholesale and Retail Sector Education and Training Authority',
		id: 21,
	},
];

export const companyTypeList: IDropDownOptions[] = [
	{ value: 'Sole Proprietor', id: 1 },
	{ value: 'Close Corporation (CC)', id: 2 },
	{ value: 'Proprietary Limited (Pty) Ltd', id: 3 },
	{ value: 'Trust', id: 4 },
	{ value: 'Joint Venture', id: 5 },
	{ value: 'Limited', id: 6 },
	{ value: 'Non-Profit Company / Organisation', id: 8 },
	{ value: 'Incorporated', id: 9 },
	{ value: 'Partnership', id: 11 },
	{ value: 'State-owned entity', id: 12 },
	{ value: 'Co-operative', id: 13 },
];

export const ticketStatusList: IDropDownOptions[] = [
	{ value: 'Open', id: 1 },
	{ value: 'In Progress', id: 2 },
	{ value: 'Resolved', id: 3 },
];

export const ticketTypeList: IDropDownOptions[] = [
	{ value: 'BBBEE Advisory', id: 1 },
	{ value: 'Calculations', id: 2 },
	{ value: 'Data Transfer', id: 3 },
	{ value: 'Notes', id: 4 },
	{ value: 'Own Target', id: 5 },
	{ value: 'Reports', id: 6 },
	{ value: 'Scenario', id: 7 },
	{ value: 'Supporting Documents', id: 8 },
	{ value: 'User Management', id: 9 },
	{ value: 'Other', id: 10 },
];

export const accountTypeList: IDropDownOptions[] = [
	{ value: 'Audited Annual Financial Statements', id: 1 },
	{ value: 'Management Accounts', id: 2 },
];

export const proposalStatusList: IDropDownOptions[] = [
	{ value: 'Pending', id: 1 },
	{ value: 'Declined', id: 2 },
	{ value: 'Accepted', id: 3 },
];

export const VerificationProcessStatusList: IDropDownOptions[] = [
	{ value: 'Planned', id: 1 },
	{ value: 'In Progress', id: 2 },
	{ value: 'Completed', id: 3 },
];

export const ClientStatusList: IDropDownOptions[] = [
	{ value: 'Enquiry Received', id: 1 },
	{ value: 'Application' , id: 2},
	{ value: 'Proposal' , id: 3,  },
	{ value: 'Risk Assessment' , id: 4 },
	{ value: 'Verification Agreement' , id: 5, },
	{ value: 'Invoice' , id: 6 },
	{ value: 'Verification Progress', id: 7, },
	{ value: 'Wrap-Up' , id: 8,},
];

export const NotifyStatusDateList: IDropDownOptions[] = [
	{ value: 'Notify on Schedule date', id: 0 },
	{ value: 'Notify on Status date', id: 1 },
];

export const ratingList: IDropDownOptions[] = [
	{ value: 'Outstanding', id: 5 },
	{ value: 'Exceeds Expectations', id: 4 },
	{ value: 'Meets Expectations', id: 3 },
	{ value: 'Needs Improvement', id: 2 },
	{ value: 'Unacceptable', id: 1 },
];

export const PercentageList: IDropDownOptions[] = [
	{ value: '0%', id: 0 },
	{ value: '10%', id: 10 },
	{ value: '20%', id: 20 },
	{ value: '30%', id: 30 },
	{ value: '40%', id: 40 },
	{ value: '50%', id: 50 },
	{ value: '60%', id: 60 },
	{ value: '70%', id: 70 },
	{ value: '80%', id: 80 },
	{ value: '90%', id: 90 },
	{ value: '100%', id: 100 },
];

export const RemunerationTypeList: IDropDownOptions[] = [
	{ value: 'High', id: 1 },
	{ value: 'Low', id: 2 },
	{ value: 'Average', id: 3 },
	{ value: 'Median', id: 4 },
	{ value: 'All', id: 5 },
];

export const StatusTypeList: IDropDownOptions[] = [
	{ value: 'Planned', id: 1 },
	{ value: 'In Progress', id: 2 },
	{ value: 'Completed', id: 3 },
];

export const EnquiryStatus: IDropDownOptions[] = [
	{ value: 'Received', id: 4 }
];

export const RiskAnalysisTypeList: IDropDownOptions[] = [
	{ value: 'Low', id: 1 },
	{ value: 'Medium', id: 2 },
	{ value: 'High', id: 3 },
];

export const ProposalAgreementStatusList : IDropDownOptions[] = [
	{ value: 'Not sent', id: 1 },
	{ value: 'Awaiting client approval', id: 2 },
	{ value: 'Renegotiation ', id: 3 },
	{ value: 'Approved by client', id: 4 },
	{ value: 'Rejected', id: 5 }
];

export const ApplicationStatusList : IDropDownOptions[] = [
	{ value: 'Not sent', id: 1 },
	{ value: 'Sent - Awaiting client submission', id: 2 },
	{ value: 'Received', id: 4 },
];

export const DefaultStatusList : IDropDownOptions[] = [
	{ value: 'Not started', id: 1 },
	{ value: 'In Progress', id: 2 },
	{ value: 'Completed', id: 4 },
];

export const InvoiceStatusList : IDropDownOptions[] = [
	{ value: 'Not sent', id: 1 },
	{ value: 'Sent', id: 2 },
	{ value: 'Partially Paid', id: 3 },
	{ value: 'Paid in full', id: 4 },
	{ value: 'Rejected', id: 5 },
];

export const WrapUpStatusList : IDropDownOptions[] = [
	{ value: 'Not started', id: 1 },
	{ value: 'Completed', id: 4 },
	{ value: 'Terminated', id: 5 },
];

export const ServiceList: IDropDownOptions[] = [
	{ value: 'BBBEE Verification', id: 1 },
	{ value: 'Gap Review', id: 2 },
	{ value: 'Ownership Review', id: 3 },
	{ value: 'Opinion', id: 4 },
	{ value: 'Joint Venture', id: 5 },
	{ value: 'Training', id: 6 },
	{ value: 'SED Beneficiary Certificate', id: 8 },
	{ value: 'Ownership Certificate', id: 9 },
	{ value: 'Re-Evaluation of Elements', id: 10 },
];

export const SectorCodeList: IDropDownOptions[] = [
	{ value: 'Information and Communication Technology', id: 1 },
	{ value: 'Transport - Bus Commuter and Coach Services', id: 2 },
	{ value: 'Financial Services Charter - Banks', id: 3 },
	{ value: 'Manufacturing and Automotive Cluster', id: 4 },
	{ value: 'Security', id: 5 },
	{ value: 'Forest', id: 6 },
	{ value: 'Agriculture', id: 7 },
	{ value: 'Tourism', id: 8 },
	{ value: 'Department of Trade and Industry', id: 9 },
	{ value: 'Property - All Other Companies', id: 10 },
	{ value: 'Construction - BEP', id: 11 },
	{ value: 'Defence', id: 12 },
	{ value: 'Construction - Contractor', id: 13 },
	{ value: 'Transport - Domestic Aviation', id: 14 },
	{ value: 'Transport - Forwarding and Clearing', id: 15 },
	{ value: 'Transport - Maritime and Services Industry', id: 16 },
	{ value: 'Transport - Public - Department of Transport', id: 17 },
	{ value: 'Transport - Public - State Owned Enterprises', id: 18 },
	{ value: 'Transport - Rail', id: 19 },
	{ value: 'Transport - Road Freight', id: 20 },
	{ value: 'Transport - Taxi Owners', id: 21 },
	{ value: 'Financial Services Charter - Life Offices', id: 22 },
	{ value: 'Financial Services Charter - Other Institutions', id: 23 },
	{ value: 'Financial Services Charter - Short-term Insurers', id: 24 },
	{ value: 'Financial Services Charter - Stock Exchange and Stock Exchange Members', id: 25 },
	{ value: 'Financial Services Charter - Retirement Fund', id: 26 },
	{ value: 'Financial Services Charter - Trade Association Specialised Enterprises', id: 27 },
	{ value: 'Property - Estate Agents', id: 28 },
	{ value: 'Property - Property Owning', id: 29 },
	{ value: 'Property - Property and Asset Managers', id: 30 },
	{ value: 'Property - APUTS Property Unit Trusts', id: 31 },
	{ value: 'Property - Owners and REITS External Management', id: 32 },
	{ value: 'Property - PLSA Loans Stock External Management', id: 33 },
	{ value: 'Property - Internal Management with PLSA/REITS', id: 34 },
	{ value: 'Property - Unlisted Mandated Collective Investment Schemes', id: 35 },
	{ value: 'Property - Specialized Entities', id: 36 },
	{ value: 'Transport - Taxi Association', id: 37 },
];

export const ScorecardTypeCategoryList: IDropDownOptions[] = [
	{ value: 'Exempted Micro Enterprise (EME)', id: 1 },
	{ value: 'Qualifying Small Enterprise (QSE)', id: 2 },
	{ value: 'Specialised Qualifying Small Enterprise', id: 3 },
	{ value: 'Qualifying Small Enterprise - Consolidated scorecard', id: 4 },
	{ value: 'Generic Enterprise', id: 5 },
	{ value: 'Specialised Generic Enterprise', id: 6 },
	{ value: 'Generic Enterprise - Consolidated scorecard', id: 7 },
	{ value: 'Joint Venture QSE scorecard', id: 8 },
	{ value: 'Joint Venture Generic scorecard', id: 9 },
];

export const BBBEECodeList: IDropDownOptions[] = [
	{ value: 'Amended Codes of Good Practice - 2019', id: 5 },
	{ value: 'Amended Information and Communication Technology Sector Code', id: 6 },
	{ value: 'Amended Property Sector Code', id: 7 },
	{ value: 'Amended Construction Sector Code', id: 8 },
	{ value: 'Amended Financial Services Sector Code', id: 9 },
	{ value: 'Amended Defence Sector Code', id: 10 },
	{ value: 'Amended AgriBEE Sector Code', id: 11 },
	{ value: 'Amended Forest Sector Code', id: 12 },
	{ value: 'Amended Tourism Sector Code', id: 13 },
	{ value: 'Amended Marketing Advertising and Communication Sector Code', id: 14 },
	{ value: 'Integrated Transport Sector Codes', id: 15 },
];

export const SubmissionList: IDropDownOptions[] = [
	{ value: 'First Submission', id: 0 },
	{ value: 'Resubmission', id: 1 },
	{ value: 'Re-evaluation', id: 2 },
];

export const ApplicableDataPageSubmissionActionsList: IDropDownOptions[] = [
	{ id: ActionTypes.First_Submission, value: 'Accept - First evaluation' },
	{ id: ActionTypes.Resubmission, value: 'Accept - Re-submission' },
	{ id: ActionTypes.Reevaluation, value: 'Accept - Re-evaluation' },
	{ id: ActionTypes.Reject, value: 'Reject' },
];

export const ApplicableDataPageAccessRequestActionsList: IDropDownOptions[] = [
	{ id: ActionTypes.Resubmission, value: 'Accept - Re-submission' },
	{ id: ActionTypes.Reevaluation, value: 'Accept - Re-evaluation' },
	{ id: ActionTypes.Reject, value: 'Reject' },
];

export const trainingTypesList: IDropDownOptions[] = [
	{ id: 'LAI', value: 'LAI' },
	{ id: 'Internal', value: 'Internal Training' },
	{ id: 'External', value: 'External Training' },
];

export const NotificationTriggerListForPlanner: IDropDownOptions[] = [
	{ id: 1, value: 'Status change' },
	{ id: 2, value: 'Scheduled date'}
];

export const NotificationTriggerListForApplicationTracker: IDropDownOptions[] = [
	{ id: 3, value: 'Status change' },
	{ id: 4, value: 'Days elapsed without status change'}
];

export const YesNoList: IDropDownOptions[] = [
	{ id: 0, value: 'No' },
	{ id: 1, value: 'Yes' }
];

export const incomeDifferentialsOptions: IDropDownOptions[] = [
    { id: 1, value: 'a) Seniority/ length of service' },
    { id: 2, value: 'b) Qualifications' },
    { id: 3, value: 'c) Performance' },
    { id: 4, value: 'd) Demotion' },
    { id: 5, value: 'e) Experiential training'},
    { id: 6, value: 'f) Shortage of skill' },
    { id: 7, value: 'g) Transfer of business' },
    { id: 8, value: 'h) Other' }
];

export const EEOccupationalLevelNamingConventionList: IDropDownOptions[] = [
	{ value: 'Top Management', id: 1 },
	{ value: 'Senior Management', id: 5 },
	{ value: 'Middle Management', id: 6 },
	{ value: 'Junior Management', id: 7 },
	{ value: 'Semi skilled', id: 8 },
	{ value: 'Unskilled', id: 9 },
];

export const payrollImportTypeOptions: IDropDownOptions[] = [
	{ id: 0, value: 'Employee Structure Only' },
	{ id: 1, value: 'Employee Structure and Salaries' },
];